let domain = '';
let baseUrl = '';

if (process.env.NODE_ENV === 'development') {
    domain = 'https://cdn.dsmcdn.com/';
    baseUrl = 'https://cdn.dsmcdn.com/';
} else {
    domain = 'https://cdn.dsmcdn.com/';
    baseUrl = 'https://cdn.dsmcdn.com/';
}

export {
    domain,
    baseUrl
}

